export default {"src":"/_next/static/media/landing-image.5b463035.svg","height":1200,"width":1600};